



























import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import iwInputGroupStepper from "../buildingBlocks/InputGroupStepper.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { mapGetters } from "vuex";
import { scrollToPriceInput } from "@/shared/scripts/helpers/function";

export default Vue.extend({

    components: {
        iwInputGroupStepper: iwInputGroupStepper,
        iwTooltip: iwTooltip,
    },
    data: function () {
        return {
            specificId: uuidv4() as string,
            maximumBedroomSurfaces: 5,
            pathInStore: "property.bedroom.count",
            internalBedroomSurface: 0,
            bedroomsSurfaces: [] as Array<Record<string,number>>
        };
    },
    computed: {
        ...mapGetters({
            isReadonlyField: "FormModule/isReadonlyField",
            editNotAllowed: "FormModule/editNotAllowed"
        }),
        bedroomCount: {
            get: function(): number {
                return this.$store.getters["FormModule/getValue"](this.pathInStore) || 0;
            },
            set: function(value: number) {
                this.$store.dispatch("FormModule/addValue", { path: this.pathInStore, value: value });
            }
        },
        editExpirationDate: function(): string | null {
            return this.$store.getters["FormModule/editExpirationDate"];
        },
        isDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
    },
    watch: {
        bedroomCount: function(newValue: number, oldValue: number) {
            if(newValue < oldValue) {
                this.bedroomsSurfaces.splice((newValue),1);
                this.removeBedroomSurface();
            }
        },
    },
    mounted: function(){
        if(this.$store.getters["FormModule/getValue"](this.pathInStore) == null && this.isDisplayed) {
            this.$store.dispatch("FormModule/addValue", {"path": "property.bedroom.count", "value": 0});
        }
    },
    methods: {
        updateValue: function(bedroomCount: number): void {
            this.$store.dispatch("FormModule/addValue", {"path": "property.bedroom.count", "value": bedroomCount});
            this.bedroomCount = bedroomCount;
            this.$store.dispatch("FormModule/addValue", {"path": "property.bedroom.items", "value": this.bedroomsSurfaces});
            if(this.bedroomCount <= this.maximumBedroomSurfaces) {
                this.internalBedroomSurface = this.bedroomCount;
            }
            
            this.$nextTick(() => {
                scrollToPriceInput("label[id*=\"input-sale-price-label\"], label[id*=\"input-rent-requested-monthly-price-label\"]");
            });
        },

        updateBedroomSurface: function(bedroomSurface: number, index: number): void {
            const newBedroomSurface = {
                surface: bedroomSurface
            };
            this.bedroomsSurfaces[index] = newBedroomSurface;
            this.$store.dispatch("FormModule/addValue", {"path": "property.bedroom.items", "value": this.bedroomsSurfaces});            
        },

        removeEmptyBedroomSurface: function() {
            this.bedroomsSurfaces = this.bedroomsSurfaces.filter(bedroomSurface => bedroomSurface.surface !== 0);
            this.$store.dispatch("FormModule/addValue", {"path": "property.bedroom.items", "value": this.bedroomsSurfaces});            
        },

        removeBedroomSurface: function(): void {
            if(this.bedroomCount === 0) {
                this.$store.commit("FormModule/deleteValue", "property.bedroom.items");
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": "property.bedroom.items", "value": this.bedroomsSurfaces});
            }
        },
    },

});
